import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Checkbox from '@mui/material/Checkbox';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';


const Text = styled(Typography)({
    color: "#000000",
    //transform: "scale(0.9)",
});


//ここを参照元から受け取った項目リストにすれば他の機能でも利用できるはず。

const columnTitle = [
    {
        id: 'title',
        numeric: true,
        disablePadding: false,
        label: '',
        align: 'center',
    },
    {
        id: 'ryoko',
        numeric: true,
        disablePadding: false,
        label: '良好',
        align: 'center',
        value: 1
    },
    {
        id: 'kyuyu',
        numeric: true,
        disablePadding: true,
        label: '給油',
        align: 'center',
        value: 2
    },
    {
        id: 'chosei',
        numeric: true,
        disablePadding: true,
        label: '調整',
        align: 'center',
        value: 3
    },

    {
        id: 'oteire',
        numeric: true,
        disablePadding: true,
        label: '交換・お手入れ必要',
        align: 'center',
        value: 4
    },
    {
        id: 'kokan',
        numeric: true,
        disablePadding: false,
        label: '本日交換',
        align: 'center',
        value: 5
    },
    {
        id: 'chosa',
        numeric: true,
        disablePadding: false,
        label: '精密調査必要',
        align: 'center',
        value: 6
    }
]
const Cells = [
    {
        id: 'ryoko',
        numeric: true,
        disablePadding: false,
        label: '良好',
        align: 'center',
        value: 1
    },
    {
        id: 'kyuyu',
        numeric: true,
        disablePadding: true,
        label: '給油',
        align: 'center',
        value: 2
    },
    {
        id: 'chosei',
        numeric: true,
        disablePadding: true,
        label: '調整',
        align: 'center',
        value: 3
    },

    {
        id: 'oteire',
        numeric: true,
        disablePadding: true,
        label: '交換・お手入れ必要',
        align: 'center',
        value: 4
    },
    {
        id: 'kokan',
        numeric: true,
        disablePadding: false,
        label: '本日交換',
        align: 'center',
        value: 5
    },
    {
        id: 'chosa',
        numeric: true,
        disablePadding: false,
        label: '精密調査必要',
        align: 'center',
        value: 6
    }
]

export default function CheckListTable(props) {
    const [checkedStatus, setCheckedStatus] = useState(() => {
        // 初期値を設定する
        const initialStatus = {};
        props.RowTitle.forEach((row, index) => {
            Cells.forEach((cell) => {
                if (row.value === cell.value) {
                    // row.idとcell.idをキーにチェックをtrueに設定
                    if (!initialStatus[index]) {
                        initialStatus[index] = {};
                    }
                    initialStatus[index][cell.id] = true;
                }
            });
        });
        return initialStatus;
    });
    const [checkStatusList, setCheckStatusList] = useState(() => {
        // 初期値を設定する
        const initialStatus = {};
        props.RowTitle.forEach((row) => {
            Cells.forEach((cell) => {
                if (row.value === cell.value) {
                    // row.idとcell.idをキーにチェックをtrueに設定
                    if (!initialStatus[row.id]) {
                        initialStatus[row.id] = {};
                    }
                    initialStatus[row.id] = cell.value;
                }
            });
        });
        return initialStatus;
    });

    useEffect(() => {
        const initialStatus = {};
        props.RowTitle.forEach((row, index) => {
            Cells.forEach((cell) => {
                if (row.value === cell.value) {
                    // row.idとcell.idをキーにチェックをtrueに設定
                    if (!initialStatus[index]) {
                        initialStatus[index] = {};
                    }
                    initialStatus[index][cell.id] = true;
                }
            });
            setCheckedStatus(initialStatus)
        });
    },[props.resetValues])

    const onCheckList = (status, rowIndex, cellId, rowId, rowValue) => {
        const newStatus = { ...checkedStatus };
        if (!newStatus[rowIndex]) {
            newStatus[rowIndex] = {};
        }

        newStatus[rowIndex][cellId] = status;
        setCheckedStatus(newStatus);
        if (status === true) {
            const updateCheckStatus = (rowId, rowValue) => {
                setCheckStatusList(prevState => ({
                    ...prevState,      // 既存のオブジェクトを保持
                    [rowId]: rowValue  // 新しいキーと値を追加または更新
                }));
            };

            updateCheckStatus(rowId, rowValue);
        } else {
            const updateCheckStatus = (rowId, rowValue) => {
                setCheckStatusList(prevState => ({
                    ...prevState,      // 既存のオブジェクトを保持
                    [rowId]: 0  // 新しいキーと値を追加または更新
                }));
            };
            updateCheckStatus(rowId, rowValue);
        }
    };

    // 参照元にチェックされている値を渡す
    useEffect(() => {
        props.setValue(checkStatusList);
    }, [checkedStatus, props.setValue]);
    

    const isAnyCheckedInRow = (rowIndex) => {
        return checkedStatus[rowIndex] && Object.values(checkedStatus[rowIndex]).some(val => val === true);
    };

    return (
        <div>
            <Paper sx={{ width: '100%', boxShadow: 0, bgcolor: "transparent" }}>
                <TableContainer>
                    <Table sx={{ minWidth: 600 }} align="center">
                        <TableHead>
                            <TableRow>
                                {columnTitle.map((headCell) => (
                                    <TableCell align="center" width="150px" sx={{ p: 0 }} key={headCell.id}>
                                        <Text sx={{ fontSize: '1.5rem' }}>{headCell.label}</Text>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.RowTitle.map((row, rowIndex) => {
                                const anyChecked = isAnyCheckedInRow(rowIndex);
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell align="left" width="170px" sx={{ px: 0.5, fontSize: '1.3rem' }}>{row.label}</TableCell>
                                        {Cells.map((cellRow) => {
                                            return (
                                                <TableCell align="center" width="100px" sx={{ p: 0 }} key={cellRow.id}>
                                                    <Checkbox
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: '2rem' } }}
                                                        disabled={anyChecked && !checkedStatus[rowIndex]?.[cellRow.id]}
                                                        checked={checkedStatus[rowIndex]?.[cellRow.id] || false}
                                                        value= ""
                                                        onChange={(event) => onCheckList(event.target.checked, rowIndex, cellRow.id, row.id, cellRow.value)}
                                                    />
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    );
}
